export default {
    /**
     * Checks whether there are enuy errors.
     *
     * @param   {object}  state Vuex state.
     * @returns {boolean}       Check result.
     */
    hasErrors(state) {
        return 0 < Object.values(state.errors).filter((error) => !! error).length;
    },

    /**
     * Gets the error.
     *
     * @param  {object} state Vuex state.
     * @returns {string|undefined}       Field error.
     */
    getError(state) {
        return (key) => state.errors[key];
    },

    /**
     * Checks whether field has error.
     *
     * @param  {object} state Vuex state.
     * @param  {object} getters Vuex getters.
     * @returns {boolean}     Check result.
     */
    hasError(state, getters) {
        return (key) => !! getters.getError(key);
    },
};
